module.exports = __webpack_public_path__ + "static/media/glucose-diary.81296ffc.svg";